module.exports = __webpack_public_path__ + "static/Chubb-d995e45331e8276c5ad7e8d2518d787e.png";